export default "__VITE_ASSET__CYiulY9S__"